import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformHandoverDisputeCreate } from './contest-handover-disputes.transformers';
import type { ContestHandoverDisputesCollection } from './contest-handover-disputes.types';

export function contestHandoverDisputesReducer(
  state: CollectionStateSlice<ContestHandoverDisputesCollection> = {},
  action: CollectionActions<ContestHandoverDisputesCollection>,
): CollectionStateSlice<ContestHandoverDisputesCollection> {
  switch (action.type) {
    case 'API_PUSH_SUCCESS': {
      if (action.payload.type === 'contestHandoverDisputes') {
        const { result, ref, document } = action.payload;
        return mergeWebsocketDocuments<ContestHandoverDisputesCollection>(
          state,
          transformIntoDocuments(
            [result],
            transformHandoverDisputeCreate,
            document as { handoverId: number; description: string },
          ),
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
